
import { BottomNav } from '../common/BottomNav.js';

export const MythologyScreen = () => {
    // Alt Kategori Verileri
    const categories = [
        { id: 'roma', name: 'Roma Mitolojisi', img: 'roma.png' },
        { id: 'yunan', name: 'Yunan Mitolojisi', img: 'yunan.png' },
        { id: 'turk', name: 'Türk Mitolojisi', img: 'turk.png' },
        { id: 'iskandinav', name: 'İskandinav Mitolojisi', img: 'iskandinav.png' },
        { id: 'misir', name: 'Mısır Mitolojisi', img: 'misir.png' }
    ];

    const generateGridItems = () => {
        return categories.map(cat => `
            <div class="myth-card" data-sub="${cat.name}">
                <div class="myth-img-container">
                    <img src="${new URL(`../../assets/images/mythology/${cat.img}`, import.meta.url).href}" alt="${cat.name}">
                </div>
                <div class="myth-title">${cat.name}</div>
            </div>
        `).join('');
    };

    return `
        <div id="mythology-screen" class="screen">
            <!-- Header -->
            <div class="screen-header">
                <button id="back-btn-myth" class="back-btn" onclick="const container = document.getElementById('academic-categories-container'); if(container) { container.classList.remove('hidden'); } window.Router.showScreen('category-screen');">
                    <span class="icon">⬅️</span> GERİ
                </button>
                <!-- Logo Removed Request -->
            </div>

            <div class="myth-container">
                <h2 class="myth-header">MİTOLOJİ DÜNYASI</h2>
                <p class="myth-desc">Bir mitoloji seç ve efsanelere meydan oku!</p>
                
                <div class="myth-grid">
                    ${generateGridItems()}
                </div>
            </div>

            ${BottomNav()}
        </div>
    `;
};
